import { render, staticRenderFns } from "./d-reviews-count.vue?vue&type=template&id=11c3d1ca&scoped=true&"
import script from "./d-reviews-count.vue?vue&type=script&lang=js&"
export * from "./d-reviews-count.vue?vue&type=script&lang=js&"
import style0 from "./d-reviews-count.vue?vue&type=style&index=0&id=11c3d1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3d1ca",
  null
  
)

export default component.exports